import { useLocation } from "react-router-dom";
import { useState } from "react";
import { CONTENT } from "../data/educationalContent";
import { ALL_TABS } from "../data/sidebarConfig";
import { ChevronRight, Sparkles } from "lucide-react";
import { DetailDrawer } from "../components/DetailDrawer";

export default function EducationalPage() {
  const { pathname } = useLocation();
  const tab = ALL_TABS.find(t => t.path === pathname);
  const key = pathname.replace(/^\//, "").replace(/\//g, "-");
  const data = CONTENT[key] || CONTENT[tab?.id] || {
    title: tab?.label || "Module",
    subtitle: "Contenu en construction — utilise l'IA pour approfondir n'importe quel item.",
    intro: "Ce module est en cours de rédaction. Tu peux dès maintenant cliquer sur n'importe quel item pour obtenir un deep-dive Claude Sonnet 4.5.",
    sections: [],
  };
  const [openItem, setOpenItem] = useState(null);

  return (
    <div className="animate-fadeUp space-y-8" data-testid="educational-page">
      <header className="border-l-2 border-[#CCFF00] pl-5">
        <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-[#CCFF00] mb-2">// MODULE STRATÉGIQUE</div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-white tracking-tight leading-tight">{data.title}</h1>
        <p className="text-zinc-400 text-base sm:text-lg mt-3 max-w-3xl">{data.subtitle}</p>
      </header>

      <div className="border border-[#1E1E24] bg-[#0A0A0C] rounded-sm p-6 max-w-4xl">
        <div className="text-[10px] font-mono uppercase tracking-[0.18em] text-zinc-500 mb-3">Introduction</div>
        <p className="text-zinc-200 leading-relaxed">{data.intro}</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        {data.sections.map((section, i) => (
          <section key={i} className="border border-[#1E1E24] bg-[#0A0A0C] rounded-sm p-6">
            <div className="flex items-center gap-2 mb-5">
              <span className="text-[10px] font-mono text-[#CCFF00]">[{String(i + 1).padStart(2, "0")}]</span>
              <h2 className="font-display text-xl font-semibold text-white">{section.title}</h2>
            </div>
            <ul className="space-y-2">
              {section.items.map((item, j) => {
                const [head, body] = Array.isArray(item) ? item : [item.head, item.body];
                return (
                  <li key={j}>
                    <button
                      onClick={() => setOpenItem({ head, body, sectionTitle: section.title, pageTitle: data.title })}
                      data-testid={`edu-item-${i}-${j}`}
                      className="w-full text-left group border border-[#1E1E24] hover:border-[#CCFF00]/40 bg-[#0C0C0E] hover:bg-[#0E0E11] rounded-sm p-3 transition-all"
                    >
                      <div className="flex items-start justify-between gap-3">
                        <div className="flex-1 min-w-0">
                          <div className="text-white text-sm font-medium leading-tight">{head}</div>
                          <div className="text-zinc-400 text-xs mt-1.5 leading-relaxed">{body}</div>
                        </div>
                        <ChevronRight className="w-4 h-4 text-zinc-600 group-hover:text-[#CCFF00] shrink-0 transition" />
                      </div>
                      <div className="mt-2 flex items-center gap-1 text-[9px] font-mono uppercase tracking-wider text-[#00D4FF] opacity-50 group-hover:opacity-100 transition">
                        <Sparkles className="w-2.5 h-2.5" />
                        <span>Approfondir IA</span>
                      </div>
                    </button>
                  </li>
                );
              })}
            </ul>
          </section>
        ))}
      </div>

      <DetailDrawer
        open={!!openItem}
        onOpenChange={(o) => !o && setOpenItem(null)}
        title={openItem?.head || ""}
        subtitle={openItem?.body}
        details={null}
        aiContext={openItem ? {
          topic: openItem.head,
          context: `Page: ${openItem.pageTitle}. Section: ${openItem.sectionTitle}. Description courte: ${openItem.body}. Donne un deep-dive ultra concret avec stats, actions du jour, checklist, KPIs, erreurs, pro tips et exemples.`,
          platform: ""
        } : null}
      />
    </div>
  );
}
